export class PrebidOnProduct {
    prebidOnProductId: number;
    auctionClusterId: number;
    buyerId: number;
    subbuyerId: number;
    subnumber: number;
    price: number = 0;
    productId: number;
    spentAmountPrebid: number = 0;
    amountWanted: number = 0;
    amountBought: number = 0;
    minAmount: number = 0;
    maxAmount: number = 0;
    allOrNothing: boolean = false;
    createdBy: string; 
    updatedBy: string; 

    prebidOnProductProperties: Array<PrebidOnProductProperty> = [];
    displayPrebidOnProductProperties: Array<PrebidOnProductProperty> = [];
}

export class PrebidOnProductProperty {
    prebidOnProductPropertyId: number;
    prebidOnProductId: number;
    auctionClusterId: number;
    productPropertyId: number;
    productId: number;
    intValue: number;
    decimalValue: number;
    stringValue: string;
    dateTimeValue: Date;
    booleanValue: boolean;
    urlValue: string;
    masterDataListRowId: number;
    masterDataListId: number;

    displayValue: any;
    orderNumber: number;
    masterDataListFieldId: number;
    name: string;
    propertyTypeId: number;
    propertyTypeFormatId: number;
    translatable: boolean;
    required = true;
}
